import React from "react";
import "./styles.scss";
import { GetIcon } from "../../config/icon";

const Index = ({ data, onClick }) => {
  return (
    <div className="icon-main-wrapper" onClick={onClick}>
      <div className="icon-container">
        <div className="circle">{GetIcon(data?.iconType)}</div>
        <div className="icon-label"></div>
      </div>
    </div>
  );
};

export default Index;
